import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchTicketDetail } from "../Services/fetchTicketDetail";


export default function useTicketDetail({ ticketId, countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "ticketDetail", { ticketId, countryId }],
    queryFn: () => fetchTicketDetail({ accessToken, ticketId, countryId }),
    staleTime: 0,
    enabled: !!ticketId && !!countryId && !!accessToken,
    retry: false,
  });
}
